/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './blocklist-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-blocklist-list-page',
  template
})
export class BlocklistListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.inv.blocklists.blocklist';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
